export const monedaListaSeleccion = `
$filter=Ambito eq 'Usuario.PreferenciaMoneda'&$select=Nombre,ListaSeleccionId,Valor
`

export const monedaListaSeleccionById = `
$filter=Ambito eq 'Usuario.PreferenciaMoneda' and ListaSeleccionId eq {ID} &$select=Nombre,ListaSeleccionId`
